export default value => /[0-9]/.test(value);
